import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { centerProfileDetails, restaurantProfileDetails, updateCenterProfile } from "../../services/profile.services";
import Swal from "sweetalert2";
import { LOADER_TIMEOUT_TIME, PHONE_NO_LENGTH, ROLE, SWAL_SETTINGS } from "../../../../utils/Constants";
import { useValidationSchemas } from "../../validator/validation";
import { getDateWithTime, getUser, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import CustomError from "../../../../utils/customError";
import Skeleton from "react-loading-skeleton";
import PhoneInput from "../../../../utils/PhoneInput";
import PhoneWorkInput from "../../../../utils/PhoneWorkInput";
import { Link } from "react-router-dom";

export default function CenterProfile() {
  const [showPassword, setShowPassword] = useState(false);
  const { restaurantProfileValidationSchema } = useValidationSchemas();
  const fileSelectInput = useRef();
  const componentRef = useRef();
  const printRef = useRef();
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [profileSubmissionform, setProfileSubmissionForm] = useState(false);
  const [passwordSubmissionform, setPasswordSubmissionForm] = useState(false);
  const [fiscalSubmissionform, setFiscalSubmissionForm] = useState(false);
  const toggleEyeIcon = () => {
    showPassword ? setShowPassword(false) : setShowPassword(true);
  };

  const profileForm = useFormik({
    initialValues: {
      centerId: "",
      centerName: "",
      centerAddress: "",
      center_logo: "",
      email : ""
    },
    enableReinitialize: true,
    validationSchema: restaurantProfileValidationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("center_name", values.centerName);
      formData.append("address", values.centerAddress);
      formData.append("city", values.city);
      formData.append("pin_code", values.pin_code);
      formData.append("phone_number", values.phone_number);
      formData.append("phone_number_work", values.phone_number_work);
      formData.append("center_logo", values.center_logo);
      formData.append("email", values.email);
      setProfileSubmissionForm(true);
      updateCenterProfile(formData)
        .then((response) => {
          setProfileSubmissionForm(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setProfileSubmissionForm(false);
          console.error("Error updating profile", error);
        });
    },
  });

  useEffect(() => {
    const userId = getUser(ROLE.CENTER)?._id;
    setLoader(true);
    centerProfileDetails({ o_id: userId }, userId)
      .then((data) => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        profileForm.setValues({
          centerId: data?.data?.center_register_id || "",
          centerName: data?.data?.center_name || "",
          centerAddress: data?.data?.address || "",
          city: data?.data?.city || "",
          pin_code: data?.data?.pin_code || "",
          center_logo: data?.data?.center_logo || "",
          phone_number :  data?.data?.phone_number || "",
          phone_number_work :  data?.data?.phone_number_work || "",
          email :  data?.data?.email || "",
        });
      })
      .catch((err) => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        console.log(err);
      });
  }, []);

  const handleFileSelection = (event) => {
    if (event.target.files.length) {
      profileForm.setFieldValue("center_logo", event.target.files[0]);
    }
  };
  const handleFilePreview = (file) => {
    if (typeof file === "string") {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };


  return (
    <>
      {/* <main id="main-content">
        <div className="inner-container">
          <div className="page-header d-flex align-items-center">
            <h4 className="heading-title-text">{t("Center Profile")}</h4>
          </div>
          <div className="card">
            <div className="card-body">
              {loader ? (
                <div className="">
                  <Skeleton circle={true} style={{ width: "96px", height: "96px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                </div>
              ) : (
                <form onSubmit={profileForm.handleSubmit}>
                  <div className="d-flex align-items-center justify-content-between py-2" style={{ height: "16rem" }}>
                    <div className="profile-photo-upload mb-3">
                      <div className="avatar avatar-xl">
                        <img alt="center_logo" src={handleFilePreview(profileForm?.values?.center_logo)} />
                      </div>
                      <button
                        className="cp e_none"
                        type="button"
                        onClick={() => {
                          fileSelectInput?.current?.click();
                        }}
                      >
                        <input ref={fileSelectInput} id="center_logo" name="center_logo" accept="image/*" type="file" onChange={handleFileSelection} />
                        <i className="ti ti-upload"></i>
                      </button>
                    </div>
                    <CustomError name="center_logo" form={profileForm} className="text-danger my-3" />
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {t("Center ID")}
                          <span>*</span>
                        </label>
                        <input type="text" className="form-control" disabled value={profileForm.values.centerId} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {t("Center Name")}
                          <span>*</span>
                        </label>
                        <input type="text" className="form-control" name="centerName" placeholder="Enter center name" onChange={profileForm.handleChange} value={profileForm.values.centerName} />
                        <CustomError name="centerName" form={profileForm} className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {t("Email")}
                          <span>*</span>
                        </label>
                        <input type="text" className="form-control"  disabled value={profileForm.values.email} name="email" placeholder="Enter email" onChange={profileForm.handleChange} />
                        <CustomError name="email" form={profileForm} className="text-danger" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 input-address">
                        <label className="form-label">
                          {t("Location")}
                          <span>*</span>
                        </label>
                        <input type="text" className="form-control" name="centerAddress" placeholder="Enter location" onChange={profileForm.handleChange} value={profileForm.values.centerAddress} />
                        <CustomError name="centerAddress" form={profileForm} className="text-danger" />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className="mb-3">
                        <label htmlFor='phone_number' className="form-label">{t("center.profile.label_phone_number")}<span>*</span></label>
                        <PhoneInput
                          value={profileForm?.values?.phone_number}
                          name={'phone_number'} onChange={(e) => { profileForm.setFieldValue('phone_number', e?.phone_number) }} onBlur={profileForm.handleBlur} />
                        <CustomError name="phone_number" form={profileForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                      </div>
                    </div>
                  </div>
                  <div className="button-form">
                    <button type="submit" className={"btn btn-primary" + (profileSubmissionform ? " btn-loader" : "")}>
                      {t("center.cafe_profile.btn_update_profile")}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </main> */}
       <main id='main-content'>
            <div className='inner-container'>
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li className="nav-item">
                        <Link className="nav-link active" to={'/center/profile'}>{t("My Profile")}</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to={'/center/profile/change-password'}>{t("Change Password")}</Link>
                    </li>
                </ul>
                 {/* <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-Credit" type="button" role="tab" aria-controls="pills-Credit"
                            aria-selected="true">Credit</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-Debit-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-Debit" type="button" role="tab" aria-controls="pills-Debit"
                            aria-selected="false">Debit</button>
                    </li>
                </ul> */}
                <div className='card'>
                    <div className='card-body'>
                        {loader ?
                            <div className='w-100'>
                                <Skeleton circle={true} style={{ width: "96px", height: "96px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                                <Skeleton className='mt-4' style={{ height: "30px" }} />
                            </div>
                            :
                            <form onSubmit={profileForm.handleSubmit}>
                            <div className="d-flex align-items-center justify-content-between py-2" style={{ height: "16rem" }}>
                              <div className="profile-photo-upload mb-3">
                                <div className="avatar avatar-xl">
                                  <img alt="center_logo" src={handleFilePreview(profileForm?.values?.center_logo)} />
                                </div>
                                <button
                                  className="cp e_none"
                                  type="button"
                                  onClick={() => {
                                    fileSelectInput?.current?.click();
                                  }}
                                >
                                  <input ref={fileSelectInput} id="center_logo" name="center_logo" accept="image/*" type="file" onChange={handleFileSelection} />
                                  <i className="ti ti-upload"></i>
                                </button>
                              </div>
                              <CustomError name="center_logo" form={profileForm} className="text-danger my-3" />
                            </div>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {t("Center ID")}
                                    <span>*</span>
                                  </label>
                                  <input type="text" className="form-control" disabled value={profileForm.values.centerId} />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {t("Center Name")}
                                    <span>*</span>
                                  </label>
                                  <input type="text" className="form-control" name="centerName" placeholder="Enter center name" onChange={profileForm.handleChange} value={profileForm.values.centerName} disabled />
                                  <CustomError name="centerName" form={profileForm} className="text-danger" />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {t("Email")}
                                    <span>*</span>
                                  </label>
                                  <input type="text" className="form-control"  disabled value={profileForm.values.email} name="email" placeholder="Enter email" onChange={profileForm.handleChange}  />
                                  <CustomError name="email" form={profileForm} className="text-danger" />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3 input-address">
                                  <label className="form-label">
                                    {t("Location")}
                                    <span>*</span>
                                  </label>
                                  <input type="text" className="form-control"  disabled name="centerAddress" placeholder="Enter location" onChange={profileForm.handleChange} value={profileForm.values.centerAddress} />
                                  <CustomError name="centerAddress" form={profileForm} className="text-danger" />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3 input-address">
                                  <label className="form-label">
                                    {t("City")}
                                  </label>
                                  <input type="text" className="form-control" disabled  name="city" placeholder="Enter location" onChange={profileForm.handleChange} value={profileForm.values.city} />
                                  {/* <CustomError name="city" form={profileForm} className="text-danger" /> */}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3 input-address">
                                  <label className="form-label">
                                    {t("PIN Code")}
                                  </label>
                                  <input type="text" className="form-control" disabled  name="pin_code" placeholder="Enter PIN code" onChange={profileForm.handleChange} value={profileForm.values.pin_code} />
                                  <CustomError name="pin_code" form={profileForm} className="text-danger" />
                                </div>
                              </div>
                              <div className='col-md-6'>
                                <div className="mb-3">
                                  <label htmlFor='phone_number' className="form-label">{t("center.profile.label_phone_number")}<span>*</span></label>
                                  <PhoneInput
                                    value={profileForm?.values?.phone_number}
                                    disabled
                                    name={'phone_number'} onChange={(e) => { profileForm.setFieldValue('phone_number', e?.phone_number) }} onBlur={profileForm.handleBlur} />
                                  <CustomError name="phone_number" form={profileForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                                </div>
                              </div>
                              <div className='col-md-6'>
                                <div className="mb-3">
                                  <label htmlFor='phone_number_work' className="form-label">{t("Phone Number Work")}</label>
                                  <PhoneWorkInput
                                    disabled
                                    value={profileForm?.values?.phone_number_work}
                                    name={'phone_number_work'} onChange={(e) => { profileForm.setFieldValue('phone_number_work', e?.phone_number_work) }} onBlur={profileForm.handleBlur} />
                                  {/* <CustomError name="phone_number_work" form={profileForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} /> */}
                                </div>
                              </div>
                            </div>
                            {/* <div className="button-form">
                              <button type="submit" className={"btn btn-primary" + (profileSubmissionform ? " btn-loader" : "")}>
                                {t("center.cafe_profile.btn_update_profile")}
                              </button>
                            </div> */}
                          </form>
                        }
                    </div>
                </div>
            </div>
        </main>
    </>
  );
}
